import React from "react";
import { connect } from "react-redux";
import { getters } from "Portal/CallForPapersForm/model";
import { Div } from "components/Base";

const decorate = connect(state => ({
  isViewOnly: getters.isViewOnly(state)
}));

const CloseAt = ({ isViewOnly = false }) => {
  return isViewOnly ? (
    <Div bg="gray1" bra={2} p={3} mb={3} display="row.center.center" fs={2}>
      This submission is read-only. Please contact your event administrator if
      you need to make changes.
    </Div>
  ) : null;
};

export default decorate(CloseAt);
